<res-base-modal [modalTitle]="'Download Word List'" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    [primaryButtonLabel]="'Download Word List'" (primaryButtonActionEmt)="ok()"
    [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()" (closeButtonActionEmt)="closeModal()"
    [secondaryButtonLabel]="'Cancel'" [(isBusy)]="isBusy" [isBusyMessage]="isBusyMessage"
    [modalHelpIndex]="modalHelpIndex">

    <div class="download-header">Destination</div>
    <div class="radio-column">
        <res-custom-radio-button [automationId]="modalAutomationId + 'download-to-csv'" [(ngModel)]="isDownloadToCsv"
            content="Download a .CSV file" [value]="true" ngDefaultControl
            [ngStyle]="{'margin': !hasConnAccessPermissions? '0px 10px' : '0px'}"></res-custom-radio-button>
        <res-custom-radio-button *ngIf="hasConnAccessPermissions" [automationId]="modalAutomationId + 'save-to-server'"
            [(ngModel)]="isDownloadToCsv" content="Save to Server:" [value]="false" ngDefaultControl>
        </res-custom-radio-button>
    </div>
    <div class="server-row" *ngIf="hasConnAccessPermissions">
        <label requiredAsterisk [isRequired]="!isDownloadToCsv">Export Data Area:
        </label>
        <select [(ngModel)]="selectedDataArea" [disabled]="isDownloadToCsv"
            [attr.data-automation-id]="modalAutomationId + 'data-area-option'">
            <option *ngFor="let da of exportDataAreas" [ngValue]="da">{{da.name}}</option>
        </select>
        <label></label>
        <label requiredAsterisk [isRequired]="!isDownloadToCsv">File Name:
        </label>
        <input type="text" [disabled]="isDownloadToCsv" [(ngModel)]="fileName"
            [attr.data-automation-id]="modalAutomationId + 'file-name-input'" />
        <label>.csv</label>

    </div>
</res-base-modal>